<template>
    <div class="ifs-header">
        <div class="inner">
            <h3>{{ $i18nUtil.trans("title.ShareInfoBoardManageHeader.001","정보공유 보드 관리") }} <span>{{ $i18nUtil.trans("message.ShareInfoBoardManageHeader.001","정보공유 콘텐츠를 관리하세요.") }}</span></h3>
            <button type="button" class="btn-primary-smaller" @click="callRegistBoardModal">{{ $i18nUtil.trans("button.paper.shar.add","정보 보드 추가") }}</button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import RegistBoardMoal from "@/components/cowork/general/cooperation/modal/RegistBoardModal"
export default {
    props:[],
    data(){
        return {

        }
    },
    methods:{
        ...mapActions("modals", ["showModal"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
        // 회의/협의체 카테고리 추가 모달 호출 
        callRegistBoardModal(){
            let obj = this;
            let reqData = {};
            reqData.req = obj.req;
            reqData.url = "/api/copaper/paper/getGeneratedPaperId";
            reqData.method = "post";

            obj
                .COWORK_REST_ACTION(reqData)
                .then(function (res) {
                    let errorCode = res.errorCode;
                    let addPaperId = res.result;
                    const modalInfo = {
                        title: obj.$i18nUtil.trans("title.RegistBoardModal.004","정보 보드 추가"),
                        name: "RegistShareInfoBoard",
                        method: "post",
                        width: "800px",
                        // height: "493px",
                        obj: obj.$modal, 
                        contentPath: "",
                        component: RegistBoardMoal,
                        paperId:addPaperId, 
                        selectedCategory:null
                    };
                    obj.showModal(modalInfo);
                })
                .catch(function (err) {
                console.log(err);
                });    

           
           
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/shareInfo/manage/components/ShareInfoBoardManageHeader.vue